<script setup>
import { inject } from 'vue'
const size = inject('size')
defineProps({
  mode: { type: String, default: 'default' },
  icon: { type: String, default: '' },
  title: { type: String, default: '' },
  des: { type: String, default: '' },
  showbtn: { type: Boolean, default: true }
})
</script>

<template>
  <div class="tvb-empty" :class="['empty-' + mode, size ? 'empty-' + size : '']">
    <div class="tvb-empty_wrap">
      <tvb-svg-icon v-if="icon" :name="icon" class="tvb-empty_header-icon" />
      <p class="tvb-empty_header-title" v-if="title">{{ title }}</p>
      <p class="tvb-empty_description" v-if="des">{{ des }}</p>
      <tvb-button
        v-if="showbtn"
        :animation="!['s', 'xs'].includes(size) ? '2' : ''"
        icon="icon_list_arrow_white"
        >去主頁看看</tvb-button
      >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tvb-empty {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .tvb-empty_header-icon {
    height: 200px;
    width: 300px;
  }

  .tvb-empty_header-title {
    color: #1e1e1e;
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 34px;
  }

  .tvb-empty_description {
    color: #818d95;
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 22px;
    margin-top: 4px;
  }

  :deep(.tvb-button) {
    width: 131px;
    box-sizing: border-box;
    background-color: #0062a3;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #555555;
    backdrop-filter: none;
    border-radius: 6px;
    color: rgba(255, 255, 255, 0.9);
    --tvb-button-height: 40px;
    margin-top: 24px;
    overflow: hidden;
    > .span {
      --tvb-button-padding: 0 16px 0 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.icon {
      .svg-icon {
        font-size: 12px;
        opacity: 0.85;
        margin-left: 2px;
      }
    }
  }

  &.empty-500 {
    .tvb-empty_header-title {
      margin-top: 32px;
    }
    .tvb-empty_description {
      margin-top: 16px;
    }
  }

  &.empty-s,
  &.empty-xs {
    .tvb-empty_header-icon {
      height: 120px;
      width: 180px;
    }
    .tvb-empty_header-title {
      font-size: 18px;
      line-height: 24px;
    }
    .tvb-empty_description {
      letter-spacing: 0px;
      font-size: 14px;
      line-height: 20px;
      margin-top: 2px;
    }
    :deep(.tvb-button) {
      width: 108px;
      font-size: 14px;
      letter-spacing: 0.3px;
      --tvb-button-height: 32px;
      margin-top: 12px;
      > .span {
        --tvb-button-padding: 0 11px 0 14px;
      }
      &.icon {
        .svg-icon {
          font-size: 10px;
          margin-left: 1px;
        }
      }
    }

    &.empty-500 {
      .tvb-empty_header-title {
        margin-top: 16px;
      }
      .tvb-empty_description {
        margin-top: 6px;
      }
    }
  }
}
</style>
